export class UnauthorizedResponse extends Error {
  public location: string
  constructor(url: string) {
    super(url)
    this.location = url
  }
}
